import { Controller } from "stimulus"

export default class extends Controller
  @targets: [
    'addEventSponsorshipFieldset'
    'editSponsorLink'
    'selectOrAddSponsorFieldset'
  ]

  @values =
    eventSponsorship: Object
    hasSponsor: Boolean

  hasSponsorChanged: (event) ->
    @hasSponsorValue = event.target.checked

  hasSponsorValueChanged: ->
    visibleAndEnabled = @hasSponsorValue
    @selectOrAddSponsorFieldsetTarget.disabled = @selectOrAddSponsorFieldsetTarget.hidden = !visibleAndEnabled

  eventSponsorshipChanged: (event) ->
    eventSponsorshipDataFromSelection = event.target.selectedOptions[0].dataset.model
    # If the chosen option is the "Blank" option, it won't have a data-model attribute,
    # so we just set the value to an empty object here.
    @eventSponsorshipValue = (eventSponsorshipDataFromSelection && JSON.parse(eventSponsorshipDataFromSelection)) || {}

  eventSponsorshipValueChanged: (newValue, oldValue) ->
    if @hasEditSponsorLinkTarget
      @editSponsorLinkTarget.href = newValue.edit_path
      @editSponsorLinkTarget.hidden = !newValue.edit_path

    if newValue.id
      @addEventSponsorshipFieldsetTarget.disabled = true
      @addEventSponsorshipFieldsetTarget.hidden = true
    else
      # The "Add a sponsor option" was selected.
      @addEventSponsorshipFieldsetTarget.disabled = false
      @addEventSponsorshipFieldsetTarget.hidden = false

      # If there are any values set in the "Add a sponsor fieldset" we'll nullify them.
      # This currently only works with text fields but, we currently only use text fields.
      unless oldValue == undefined
        @addEventSponsorshipFieldsetTarget.querySelectorAll('input, textarea').forEach (element) ->
          element.value = ''